module.exports = __webpack_public_path__ + "static/media/pick-up.c571ef56.mp3";